var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcessImgDoc({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 1.22222V6.72222H6.72222V9.77778H1.22222V1.22222H9.77778ZM9.77778 0H1.22222C0.55 0 0 0.55 0 1.22222V9.77778C0 10.45 0.55 11 1.22222 11H7.33333L11 7.33333V1.22222C11 0.55 10.45 0 9.77778 0ZM5.5 6.72222H2.44444V5.5H5.5V6.72222ZM8.55556 4.27778H2.44444V3.05556H8.55556V4.27778Z",
    fill: "#5627D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessImgDoc);
export default __webpack_public_path__ + "static/media/process-img-doc.73f52d3338d8838d001eb019c1b66434.svg";
export { ForwardRef as ReactComponent };